import {Directive, Input, OnDestroy, OnInit} from '@angular/core';
import {from, Subscription} from 'rxjs';
import {IziviaPlatformService} from '../../services/common/iziviaPlatform.service';
import {OVERLAYS_PRIORITY} from '../../utils/hardwareBackButtonPriority';
import {BackButtonEventOrigin} from './backButtonEventOrigin';
import {GhostComponent} from '../../utils/ghostComponent';
import {ModalControllerService} from '../../services/common/modalController.service';
import {IonNav, NavController} from '@ionic/angular';
import {switchMap} from 'rxjs/operators';

/**
 * All Ionic modals that define a back button in their header and that may be used under a WebView
 * should extend this abstract directive to handle Android back button properly
 *
 * Do not forget to call super.ngOnInit() and super.ngOnDestroy() if your component implements these hooks.
 */
@Directive()
export abstract class ModalWithBackButtonDirective extends GhostComponent implements OnInit, OnDestroy {

    @Input() ionNav: IonNav;

    private goingBack: boolean;
    private backButtonSubscription: Subscription;

    /**
     * Unfortunately, Angular cannot inject the service directly into this base class.
     * We must declare the service in each child component constructor, then pass it up to the base class by calling
     * <code>super(modalControllerService, navController, platformService)</code>.
     */
    protected constructor(protected readonly modalControllerService: ModalControllerService,
        protected readonly navController: NavController,
        protected readonly platformService: IziviaPlatformService) {
        super();
    }

    ngOnInit(): void {
        this.backButtonSubscription = this.platformService.get().backButton.subscribeWithPriority(OVERLAYS_PRIORITY, () => {
            this.back('device');
        });
    }

    ngOnDestroy(): void {
        this.backButtonSubscription?.unsubscribe();
    }

    back(eventOrigin?: BackButtonEventOrigin): void {
        if (!this.goingBack) {
            if (!this.ionNav) {
                this.modalControllerService.close()
                    .subscribe();
                return;
            }

            this.goingBack = true;
            from(this.ionNav.canGoBack())
                .pipe(
                    switchMap(canGoBack => {
                        if (canGoBack) {
                            if (eventOrigin === 'device') {
                                // here "this.navController.pop()" is not working and "this.ionNav.pop()" not trigger exception
                                return from(this.ionNav.pop());
                            } else {
                                // here "this.ionNav.pop()" work but trigger exception : SAM-1608
                                return from(this.navController.pop());
                            }
                        }

                        return this.modalControllerService.close();
                    })
                ).subscribe();
        }
    }

    generateGhost() {
    }
}
